import { CmDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';

export interface Props {
  data: CmDetailsDataStructure;
  onUpdate: () => void;
}

export enum FirmTypes {
  DA = 'DIRECTLY_AUTHORISED',
  DAE = 'DIRECTLY_AUTHORISED_EXCEPTION',
  AR = 'APPOINTED_REPRESENTATIVE',
}
